module.exports = __webpack_public_path__ + "assets/webgl/card_063_EN_L0.a3e7a2a8.jpg";